<script>
	import Router from 'svelte-spa-router';

	import SignIn from "./routes/SignIn.svelte";
	import Dashboard from "./routes/Dashboard.svelte";
	import Contacts from "./routes/Contacts.svelte";
	import Settings from "./routes/Settings.svelte";
	import Calculator from "./routes/Calculator.svelte";
	import ContactsAdd from "./routes/ContactAdd.svelte";
	import OptIn from './routes/OptIn.svelte';
	import Form from './routes/Form.svelte';

	const routes = {
		"/sign-in": SignIn,
		"/": SignIn,
		"/dashboard": Dashboard,
		"/contacts": Contacts,
		//"/contacts/add": ContactsAdd,
		"/settings": Settings,
		"/calculator": Calculator,
		"/opt-in/:contact": OptIn,
		"/form/nexgen": Form
	}

</script>

<div>
    <Router {routes} />
</div>